exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list__tile__title[data-v-2c659bb7]{font-size:14px}.v-list__group__header__prepend-icon[data-v-2c659bb7]{margin-right:-10px}.v-list__tile__action:hover .v-icon[data-v-2c659bb7]{text-decoration:none;-webkit-text-decoration-line:none!important;text-decoration-line:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c659bb7","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/NavMenu.vue
// module id = VQSY
// module chunks = 2